// i18n area 'vms' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO (lingua SORGENTE, regola
// 2026-08-03). Glossario di sezione: sýndarvél (VM), skyndimynd (snapshot),
// skjámynd (screenshot — distinta), sniðmát (template), drif (lettore CD/DVD),
// spýta út (espellere), setja inn (montare un supporto) vs tengja (collegare),
// flytja (migrare) vs færa (spostare), risasíður (pagine enormi); restano
// invariati power cycle, balloon, trunk, PXE, TPM, cloud-init/NoCloud, KMS,
// deploy, authority, crash loop, hotplug, Reset (distinto da Endurheimta).
// Sidecar anti-stantie: ../meta/vms.is-IS.meta.json.
import type { enUS } from './vms'

export const isIS: typeof enUS = {
  vms: {
    spof: {
      title: 'Óhæði frá hnút',
      single: 'Einn bilunarpunktur',
      alternativesNow: 'Valkostir núna',
      structural: 'Samkvæmt uppbyggingu',
      binding: 'Bindandi takmörkun',
      movableNow: 'Hægt að flytja núna',
    },
    title: 'Sýndarvélar',
    migratingChip: 'Flutningur í gangi',
    templateChip: 'Sniðmát',
    expendableTooltip: 'Í skertum klasa er hún meðal þeirra fyrstu sem falla og gæti ekki ræst aftur eftir missi hnúts.',
    expendableHaTooltip: 'Alltaf endurræst meðan klasinn er heilbrigður; í skertum klasa ganga vörðu VM-arnar fyrir — hún getur verið stöðvuð eða haldist slökkt þar til klasinn verður aftur heill, þá ræsist hún sjálf.',
    viewDetails: 'Sjá nánar',
    profileLegacy: 'Annað stýrikerfi',
    hugePagesNone: 'Engar — venjulegt minni',
    hugePages2M: 'Síður af stærð 2 MiB',
    hugePages1G: 'Síður af stærð 1 GiB',
    searchPlaceholder: 'Leita eftir nafni',
    name: 'Nafn',

    // Terminologia UNA (#94a): la phase si chiama 'Fase' ovunque — la
    // vecchia chiave 'state' è morta col polish della lista.
    vcpus: 'vCPU',
    memory: 'Minni',
    ipAddresses: 'IP-tölur',
    noIp: 'Ekkert IP',
    authorityNode: 'Authority',
    authorityNextStart: 'úthlutað við næstu ræsingu',
    scope: 'Scope',
    empty: 'Engin sýndarvél',
    loadError: 'Ekki tókst að sækja sýndarvélarnar — næst samband við TVirt-bakendann?',
    filterOverlay: 'overlay-net',
    filterDisk: 'diskur',
    filterImage: 'mynd',
    filteredBy: 'Síað eftir {kind}',
    filterPhase: 'Fasi',
    filterProtection: 'Vernd',
    filterAll: 'Allar',
    filterScopePlaceholder: 'Sía eftir scope',
    filtersToggle: 'Síur',
    scopeTree: {
      title: 'Scope',
      all: 'Allur klasinn',
      noChildren: 'Ekkert undir-scope hér',
      recursive: 'Taka afkomendur með',
      collapse: 'Fella scope-spjaldið saman',
      up: 'Fara upp um stig',
      countTooltip: '{direct} VM í þessu scope · {total} með afkomendum'
    },

    // Il picker ISO a due passi (#85): prima il catalogo, poi le sue ISO.
    isoPicker: {
      catalog: 'Katalógur',
      unknownCatalog: 'Utan sýnilegu katalóganna',
      noIsos: 'Engin tilbúin ISO-mynd í þessum katalógi'
    },
    actionsHeader: 'Aðgerðir',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Vélbúnaður',
      tags: 'Merki',
      age: 'Aldur',
      disk: 'diskur',
      disks: 'diskar',
      empty: 'Ekkert sniðmát — merktu slökkta VM sem sniðmát, eða klónaðu VM sem sniðmát.',
      clone: 'Klóna / deploy',
      editTags: 'Breyta merkjum',

      // Round K3 (#64): esporta il template come file .tvtpl del catalogo.
      exportAction: 'Flytja út í katalóg (.tvtpl)',
      exportTitle: 'Flytja út í katalóg',
      exportSubmit: 'Flytja út',
      exportError: 'Útflutningur mistókst',
      exportHint: 'Sniðmátið er pakkað í .tvtpl-safn (vélbúnaðarmanifest + hver diskur flattur í qcow2) sem ný VM-sniðmátsskrá í völdum katalógi. NIC, CD/DVD-miðlar og cloud-init ferðast ekki — sniðlýsingin telur upp hverja meðvitaða sleppingu.',
      exportName: 'Nafn skrárinnar',
      exportNameHint: 'Autt = <sniðmát>-export-<n>',
      exportStorageDefault: 'Lýsigagnageymsla sniðmátsins',

      // Importa da catalogo (Luca 2026-08-03): l'ingresso in toolbar del tab
      // Template — il backend K3/K4 copre tutti i formati vm-template, la
      // scelta è il FILE (il formato viaggia in sola lettura).
      importAction: 'Flytja inn úr katalógi',
      importTitle: 'Flytja inn úr katalógi',
      importHint: 'Tilbúin VM-sniðmátsskrá valda katalógsins verður sniðmát í skránni: snið skrárinnar (tvtpl, ova, ovf eða bert qcow2) ákveður sjálft hvernig hún flyst inn — þú velur aðeins skrána.',
      importFile: 'Katalógskrá',
      importFileHint: 'Aðeins ready-skrár flytjast inn — hálfupphlaðin skrá er ekki innflytjanleg',
      importNoFiles: 'Engin tilbúin VM-sniðmátsskrá í þessum katalógi — hlaðið fyrst einni upp eða flytjið eina út'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy-samhæfni',
      quickDeployNone: 'Ekki yfirlýst',
      quickDeployHint: 'Lýstu henni aðeins yfir ef golden-myndin inniheldur cloud-init (Linux) eða cloudbase-init eftir sysprep /generalize (Windows): kerfið treystir yfirlýsingunni og lítur aldrei inn í gestinn.',
      notFound: 'Sniðmát fannst ekki',
      frozen: 'Vélbúnaðarstillingarnar eru frystar: gerðu sniðmátið aftur að VM til að breyta þeim. Nafn, minnispunktar og merki haldast breytanleg.',
      storage: 'Geymsla',
      size: 'Stærð',
      configTitle: 'Stillingar (frystar)',
      usbClasses: 'Umbeðnir USB-flokkar',
      gpuClasses: 'Umbeðnir GPU-flokkar'
    },
    sharedDisksTab: {
      title: 'Samnýttir diskar',
      sharing: 'Samnýting',
      sharingNone: 'Ein tenging',
      sharingMultiwriter: 'Samnýtt skrif (multiwriter)',
      sharingReadonly: 'Samnýtt aðeins lestur',
      usedBy: 'Í notkun hjá',
      attachedTo: 'Tengdur við',
      notAttached: 'Ekki tengdur neinni VM',
      changeSharing: 'Breyta samnýtingarham',
      changeSharingTitle: 'Samnýtingarhamur',
      changeSharingLocked: 'Hamnum er aðeins hægt að breyta meðan engin VM notar diskinn',
      sharingChanged: 'Samnýtingarhamur uppfærður.',
      lun: 'Heilt LUN',
      lunNumber: 'LUN / nafnrými',
      lunWwn: 'WWN',
      lunSerial: 'Raðnúmer',
      antiAffinityWarning: 'Tveir eða fleiri meðlimir keyra á sama hnút án and-skyldleikareglu: bilun eins hnúts fellir þá alla',
      antiAffinityCreate: 'Búa til regluna',
      createSourceLun: 'Taka yfir heilt LUN markmiðsins',
      createLunNumber: 'LUN-númer (nafnrýmisauðkenni á NVMe)',
      createLunHint: 'Ekkert er úthlutað: stærðin er lesin af tækinu við yfirtöku',
      noPr: 'Engar SCSI-3 persistent reservations í þessari útgáfu: Windows Failover Cluster með klassískum samnýttum diski er ekki staðfest; klasar sem samræma sig yfir netið (GFS2/OCFS2, RHEL HA, shared-disk gagnagrunnar) eru það'
    },
    unusedDisksTab: {
      title: 'Ónotaðir diskar',
      attach: 'Tengja við VM',
      attachTitle: 'Tengja við VM',
      vm: 'Sýndarvél',
      noVms: 'Engin VM tiltæk',
      noSlots: 'Engin laus rauf á þessari VM',

      // Crea disco standalone (#87): tornato dall'Inventario pensionato, ora
      // con campo scope ESPLICITO (non c'è una VM da cui ereditare).
      create: 'Búa til disk',
      createTitle: 'Búa til disk',
      createSourceBlank: 'Tómur diskur',
      createSourceImage: 'Úr mynd í katalógnum',
      createImage: 'Mynd',
      createImageEmpty: 'Engin tilbúin VM-sniðmátsmynd í sýnilegum katalógum',
      createSizeFromImageHint: 'Forútfyllt með sýndarstærð myndarinnar — hún getur aðeins stækkað',

      // #107 (DISTRUTTIVO, ratificato): qcow2 → catalog file vm-template
      // sullo stesso storage, zero byte copiati — il disco cessa di esistere.
      convert: 'Umbreyta í VM-sniðmát…',
      convertOnlyQcow2: 'Aðeins qcow2-diskum er umbreytt — raw er ekki skráanlegt sniðmátssnið',
      convertTitle: 'Umbreyta í VM-sniðmát',
      convertSubmit: 'Umbreyta (eyðileggur diskinn)',
      convertError: 'Ekki tókst að hefja umbreytinguna',
      convertWarning: 'EYÐILEGGJANDI: diskurinn verður VM-sniðmátsskrá í völdum katalógi — sama geymsla, núll bæti afrituð — og HÆTTIR AÐ VERA TIL sem diskur. Ekki verður aftur snúið nema með því að búa til nýjan disk úr sniðmátinu.',
      convertNameHint: 'Nafn katalógskrárinnar — sjálfgefið nafn disksins',
      convertConfirm: 'Ég skil: disknum verður eytt',
      convertStarted: 'Umbreyting hafin — sniðmátið birtist í katalóginum þegar verkinu lýkur.',
      storageLockHint: 'Geymslan breytist aðeins með aðgerðinni Flytja',
      source: 'Uppruni',
      sourceClone: 'Klón af öðrum diski',
      sourceCloneLinked: 'Linked clone af öðrum diski',
      sourceImage: 'Búinn til úr mynd',
      sourceBlank: 'Búinn til tómur',
      allocated: 'Úthlutað / sýndarstærð',
      observedAt: 'Athugaður þann',
      snapshots: 'Skyndimyndir',
      snapshotsEmpty: 'Engin skyndimynd'
    },
    phase: {
      defined: 'Aldrei kveikt',
      starting: 'Í ræsingu',
      running: 'Í keyrslu',
      stopping: 'Í stöðvun',
      stopped: 'Slökkt',
      paused: 'Í hléi',
      failed: 'Í villu',
      deleting: 'Í eyðingu'
    },
    stopCause: {
      'api': 'Stöðvuð af TVirt (aðgerð eða API)',
      'guest-shutdown': 'Slökkvun hafin af stýrikerfi gestsins',
      'crash': 'Gesturinn hrundi',
      'qemu-exit': 'QEMU-ferlinu lauk óvænt',
      'host-reboot': 'Hnúturinn var endurræstur',
      'migrated': 'Flutt á annan hnút',
      'fenced': 'Felld af HA-afgirðingunni (hnúturinn kom aftur)'
    },
    detail: {
      notFound: 'Sýndarvél fannst ekki',
      details: 'Nánar',
      id: 'ID',
      scope: 'Scope',
      profile: 'Vélbúnaðarprófíll',
      firmware: 'Fastbúnaður',
      firmwareFile: 'Útgáfa UEFI-fastbúnaðar',
      firmwareUpdate: 'Uppfærsla tiltæk',
      firmwareUpdateHint: 'Vettvangurinn sendir nýrri UEFI-fastbúnað. Uppfærslan er aldrei sjálfvirk: hún er framkvæmd á slökktri VM, þegar þú ákveður það.',
      arch: 'Arkitektúr',
      node: 'Hnútur',
      bootOrder: 'Ræsiröð',
      agent: 'Staða agents',
      agentConnected: 'Tengdur',
      agentNotConnected: 'Ekki tengdur',
      protected: 'Varin',
      linkedClones: 'Tengd klón',
      restartPolicy: 'Endurræsingarstefna',
      preferredNode: 'Kjörhnútur',
      noPreference: 'Engin ósk (sjálfvirk staðsetning)',
      preferNodes: 'Kjörmerki hnúta',
      requireNodes: 'Skyldumerki hnúta',
      noPlacementTags: 'Engin',
      placementTag: 'Merki',
      placementValue: 'Gildi',
      placementAddTag: 'Bæta við merki',
      proximityHa: 'HA frá TVirt Proximity',
      proximityHaRestarts: 'HA-endurræsingar',
      proximityHaGaveUp: 'crash loop — HA gafst upp',
      failoverProtection: 'Vernd í skertum rekstri',
      protectionProtected: 'Varin',
      protectionExpendable: 'Fórnanleg í skertum rekstri',
      protectionInherit: 'Erfir',
      lastStop: 'Síðasta stöðvun',
      yes: 'Já',
      no: 'Nei',
      tabOverview: 'Yfirlit',
      tabSnapshots: 'Skyndimyndir',
      tabBackups: 'Afrit',
      hardware: 'Vélbúnaður',
      name: 'Nafn',
      hwSystem: 'Kerfi',
      hwCpu: 'CPU',
      hwMemory: 'Minni',
      hwBoot: 'Ræsing',
      hwIdentity: 'Auðkenni',
      hwCluster: 'Klasi og agent',
      cpuTopology: 'CPU-grannfræði',
      cpuModel: 'CPU-gerð',
      cpuLimit: 'CPU-hámark',
      cpuWeight: 'CPU-vægi',
      cpuNested: "Hreiðruð sýndarvæðing",
      cpuNestedHint: "Opnar vmx/svm fyrir gestinn (aðeins með CPU-gerðinni host). Á keyrandi VM tekur breytingin gildi við næsta power cycle (PendingRestart); staðsetning leyfir aðeins hnúta með nested virkt.",
      unlimited: 'Ótakmarkað',
      memory: 'Minni',
      balloon: 'Balloon',
      hugePages: 'Risasíður',
      hugePagesTradeoff: 'Minni vinna við vistfangaþýðingu og minni sem lendir aldrei á diski; í staðinn situr forðinn fastur á hnútnum meðan VM-in er kveikt, minnið tvítakahreinsast ekki lengur og ræsingin mistekst eigi hnúturinn ekki nógu margar lausar síður.',
      disks: 'Diskar',
      cdroms: 'CD/DVD-drif',
      nics: 'Nettengi',
      slot: 'Rauf',
      disk: 'Diskur',
      encrypted: 'Dulkóðaður',
      image: 'Mynd',
      emptyDrive: 'Tómt drif',
      emptyOption: '(tómt)',
      network: 'Net',
      mac: 'MAC',
      connected: 'Tengd',
      unplugged: 'Aftengd',
      noDevices: 'Ekkert',
      screenshot: 'Skjámynd',
      capturedAt: 'Tekin klukkan',
      noCapture: 'Engin skjámynd',
      snapshotName: 'Nafn',
      snapshotCreated: 'Búin til',
      snapshotMemory: 'Minni innifalið',
      noSnapshots: 'Engin skyndimynd',
      pendingRestart: 'Breytingar í bið: þær taka gildi við næsta power cycle.',
      applied: 'í gildi',
      appliedHint: 'VM-in keyrir með þessu gildi — það stillta tekur gildi við næsta power cycle.',
      actionError: 'Aðgerðin mistókst',
      actionStillRunning: 'Aðgerðin er enn í gangi: niðurstaðan er ekki enn þekkt',
      tabConsole: 'Stjórnskjár',
      consoleConnect: 'Tengjast',
      consoleDisconnect: 'Aftengjast',
      consoleConnecting: 'Tengist…',
      consoleReconnecting: 'Tengist…',
      consoleUnavailable: 'Stjórnskjárinn er tiltækur með VM í keyrslu eða í hléi.',
      consoleError: 'Tenging við stjórnskjáinn mistókst',
      consoleTaken: 'Stjórnskjásetan tekin af {user}',
      consoleReconnect: 'Tengjast aftur',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Haltu {key} inni',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Opna á öllum skjánum í nýjum flipa',
      consoleLoadFailed: 'VM fannst ekki eða heimildir ófullnægjandi',
      consoleClose: 'Loka',
      tabStats: 'Tölfræði',
      tabTasks: 'Verk',
      tabLogs: 'Annáll',
      statsCpu: 'CPU',
      statsMemory: 'Minni',
      statsDisk: 'Disk-I/O',
      statsRange: 'Bil',
      statsNoData: 'Engin gögn á bilinu — tölfræðin er mæld með VM í keyrslu.',
      statsError: 'Ekki tókst að sækja tölfræðina',
      cpuUsage: 'Notkun',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Notað',
      memGuestAvailable: 'Tiltækt (gestur)',
      schema: 'Skema',
      consoleProtocol: 'Stjórnskjár',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Lýsigagnageymsla',
      startupOnBoot: 'Ræsing við boot',
      startupOrder: 'Ræsingarröð',
      startupDelay: 'Ræsingartöf',
      seconds: 's',
      enabled: 'Virkt',
      disabled: 'Óvirkt'
    },
    actionsAvailable: 'Tiltækar aðgerðir',
    actions: {
      start: 'Ræsa',
      stop: 'Stöðva',
      pause: 'Gera hlé',
      resume: 'Halda áfram',
      reset: 'Reset',
      migrate: 'Flytja',
      clone: 'Klóna',
      moveStorage: 'Færa á geymslu…',
      moveScope: 'Færa í scope…',
      openConsole: 'Opna stjórnskjá',
      forceStop: 'Þvinga slökkvun',
      markTemplate: 'Merkja sem sniðmát',
      unmarkTemplate: 'Gera aftur að VM',
      error: 'Ekki tókst að framkvæma aðgerðina'
    },
    cordon: {
      confirmTitle: 'Hnúturinn er í viðhaldi',
      confirmHint:
        'Ekki er hægt að lækka kordónuna á meðan store klasans er niðri. Með því að staðfesta lýsir þú því yfir að þú vitir það: sýndarvélin ræsist þar engu að síður og samþykkið er skráð á verkið.',
      confirm: 'Ræsa samt'
    },
    markTemplate: {
      confirmTitle: 'Merkja {name} sem sniðmát?',
      confirmBody: 'Stillingarnar frjósa og VM-in getur ekki lengur kveikt á sér — aðeins klónast, eða orðið aftur VM. Nafn, minnispunktar og merki haldast breytanleg.',
      confirm: 'Merkja sem sniðmát',
      moved: '{name} er nú sniðmát — hún færðist í Sniðmát-flipann.'
    },
    unmarkTemplate: {
      confirmTitle: 'Gera {name} aftur að VM?',
      confirmBody: 'Sniðmátið verður aftur venjuleg VM: breytanleg og ræsanleg (næsta ræsing staðsetur hana á hnút).',
      confirm: 'Gera aftur að VM',
      moved: '{name} er aftur sýndarvél — hún færðist í Sýndarvélar-flipann.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Eftir hnútamerkjum',
      hint: 'merki=gildi, aðskilin með kommu (í AND): deciderinn velur meðal samsvarandi hnúta',
      invalid: 'Ógilt snið — notaðu merki=gildi, aðskilin með kommu',
      resolved: 'Samsvarandi meðlimir: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Flytja',
      target: 'Áfangahnútur',
      auto: 'Sjálfvirkt (Proximity)',
      hint: 'VM-in færist án power cycle. Hver geymsla sem hún snertir verður að vera deild; VM í hléi flyst í hléi.',
      error: 'Flutningnum var hafnað'
    },
    moveStorage: {
      title: 'Færa á geymslu',
      submit: 'Færa',
      target: 'Áfangageymsla',
      noTargets: 'Engin geymsla tekur við diskum',
      hint: 'Allir diskar slökktu VM-arinnar ferðast á völdu geymsluna, einn í einu, og halda id-i sínu — þeir sem eru þegar á áfangastað eru skipaðir hjá. Framvindan býr á verksíðunni.',
      error: 'Færslunni var hafnað'
    },
    moveScope: {
      title: 'Færa í scope',
      submit: 'Færa',
      target: 'Áfanga-scope',
      hint: 'VM-in skiptir um scope samstundis — id og diskar haldast, eignardiskarnir fylgja henni, og hún má haldast kveikt. Í dag býr hún í {scope}. Hver sér hana breytist með scope-inu.',
      error: 'Scope-færslunni var hafnað'
    },
    start: {
      title: 'Ræsa VM',
      submit: 'Ræsa',
      target: 'Áfangahnútur',
      auto: 'Sjálfvirkt (mælt með því)',
      recommended: 'mælt með því',
      hint: 'Veldu áfangahnút eða láttu Proximity ákveða meðal gildra kandídata. Hnútar sem geta ekki hýst hana eru óvirkir með ástæðunni.',
      error: 'Ekki tókst að ræsa VM-ina'
    },
    console: {
      media: 'CD/DVD-drif',
      mediaGuestToolsHint: 'Inniheldur TVirt Guest Tools — héðan geturðu spýtt þeim út eða fjarlægt drifið',
      slotOpsDeferred: 'Á þessum prófíl taka viðbót og fjarlæging drifa gildi við næsta power cycle (miðlaskipti eru tafarlaus).',
      mountGuestTools: 'Setja inn TVirt Guest Tools',
      ejectGuestTools: 'Spýta út TVirt Guest Tools',
      bootOrder: 'Ræsiröð',
      bootOrderHint: 'Nýja röðin vistast strax og tekur gildi við næsta power cycle — stjórnskjásetan helst tengd.'
    },
    snapshots: {
      create: 'Taka skyndimynd',
      createTitle: 'Taka skyndimynd',
      createSubmit: 'Taka',
      name: 'Nafn',
      nameHint: 'Bókstafir, tölustafir, punktur, bandstrik, undirstrik.',
      consistencyHint: 'Samkvæmnin er sjálfvirk: guest agent-inn frystir skráakerfin þegar hann svarar; annars fer VM-in í hlé andartak í kringum skyndimyndina.',
      memory: 'Taka minnið með',
      memoryHint: 'Fangar lifandi vinnsluminnið: endurheimtin heldur VM-inni áfram í keyrslu. Krefst þess að allir diskar séu qcow2.',
      currentChip: 'Þú ert hér',
      revert: 'Endurheimta',
      revertTitle: 'Endurheimta {name}?',
      revertBody: 'Diskarnir fara aftur í ástand skyndimyndarinnar; allt sem gerðist eftir hana tapast. Skyndimynd án minnis krefst stöðvaðrar VM.',
      delete: 'Eyða',
      deleteTitle: 'Eyða skyndimyndinni {name}?',
      deleteBody: 'Endurheimtarpunkturinn hverfur; innihald diskanna helst ósnert.',
      deleteMergeHint: 'Delta þess rennur saman við {children}: sérhver síðari endurheimtarpunktur helst gildur.',
      deleteDuplication: 'Ég samþykki tvöföldunina',
      deleteDuplicationHint: 'Deltað er afritað í hvern hinna {count} lesenda (barna-snapshot og, ef þetta er það núverandi, virka hausinn): notaða plássið getur vaxið í stað þess að minnka.',
      error: 'Aðgerðinni á skyndimyndinni var hafnað'
    },
    clone: {
      title: 'Klóna VM',
      submit: 'Klóna',
      name: 'Nafn afritsins',
      storage: 'Áfangageymsla diskanna',
      sameStorage: 'Sú sama og uppsprettan',
      full: 'Fullt afrit',
      fullHint: 'Afritar hvert bæti og slítur tengslin við upprunadiskana. Sjálfgefið er linked clone: tafarlaust, en hlekkjað við uppsprettuna (aðeins qcow2).',
      hint: 'Klónið heldur stillingum og fastbúnaði uppsprettunnar; MAC-vistföng og TPM-auðkenni eru ný.',
      markAs: 'Tegund klónsins',
      markAsInheritVm: 'Eins og uppsprettan (VM)',
      markAsInheritTemplate: 'Eins og uppsprettan (sniðmát)',
      markAsVm: 'Sýndarvél',
      markAsTemplate: 'Sniðmát',
      markAsHintVm: 'Veldu Sniðmát til að gera afritið að sniðmáti í einu skrefi.',
      markAsHintTemplate: 'Veldu Sýndarvél til að framkvæma deploy úr þessu sniðmáti í einu skrefi.',
      error: 'Klónuninni var hafnað'
    },
    bulk: {
      selected: 'valdar',
      deleteTitle: {
        one: 'Eyða {count} valinni VM?',
        other: 'Eyða {count} völdum VM?'
      },
      deleteBody: 'Hver VM fer gegnum sömu varnir og stök eyðing; höfnunum er skilað fyrir hvert atriði.',
      done: 'samþykktar',
      refused: 'hafnaðar'
    },
    delete: {
      button: 'Eyða',
      confirmTitle: 'Eyða {name}?',
      confirmBody: 'Sýndarvélinni og diskunum í hennar eigu verður eytt. Aðgerðin er óafturkræf.',
      keepDisks: 'Halda diskunum',
      keepDisksHint: 'Diskarnir sem urðu til með VM-inni sitja áfram á geymslu sinni sem sjálfstæðir diskar.',
      confirm: 'Eyða',
      cancel: 'Hætta við',
      error: 'Eyðing mistókst',
      blockedPhase: 'Stöðvaðu VM-ina fyrst',
      blockedProtected: 'VM-in er varin — fjarlægðu vörnina fyrst',
      blockedDeleting: 'Eyðing þegar í gangi'
    },
    logs: {
      title: 'Annáll',
      subtitle: 'Skipulagðir annálarammar verkanna sem snerta þessa VM',
      when: 'Hvenær',
      task: 'Verk',
      level: 'Stig',
      message: 'Skilaboð',
      empty: 'Enn engin annálalína',
      loadError: 'Ekki tókst að sækja annálinn — næst samband við TVirt-bakendann?'
    },
    stop: {
      title: 'Stöðva sýndarvél',
      modeGraceful: 'Mjúk slökkvun',
      modeGracefulHint: 'Stýrikerfi gestsins er beðið um að slökkva á sér á náttúrulegan hátt (ACPI); hunsi það beiðnina tekur þvinguð slökkvun við eftir tímamörkin.',
      modeForced: 'Þvinguð slökkvun',
      modeForcedHint: 'Tekur strauminn af samstundis, eins og að taka úr sambandi.',
      timeout: 'Vara-tímamörk (sekúndur)',
      timeoutHint: 'Biðin sem gestinum er veitt áður en slökkvunin er þvinguð'
    },

    // Il menu del bottone split di creazione (Luca 2026-07-23): "Da zero" apre
    // il wizard, le altre due voci sono stub di roadmap.
    createFromScratch: 'Frá grunni',
    createFromTemplate: 'Úr sniðmáti',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Keyra deploy',
      error: 'Deploy mistókst',
      compatNote: 'QuickDeploy krefst sniðmáts sem er samhæft QuickDeploy: kerfið sérsníður gestinn (net, lén, virkjun) við fyrstu ræsingu.',
      template: 'Sniðmát',
      noTemplates: 'Ekkert sniðmát lýsir enn yfir QuickDeploy-samhæfni — lýstu henni yfir á flipanum Sniðmát (Linux með cloud-init, Windows með cloudbase-init eftir sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Hýsilheiti',
      hostnameHint: 'Hýsilheiti eða FQDN; tómt = nafn VM (Windows: að hámarki 15 stafir)',
      ip: 'IP-tala',
      ipHint: 'Hýsill og forskeyti, t.d. 192.168.122.101/24; tómt = DHCP',
      gateway: 'Gátt',
      dns: 'DNS-þjónar',
      dnsHint: 'Allt að þrír, aðskildir með kommu',
      count: 'Tilvik',
      countHint: 'Fleiri en eitt: nefnd <nafn>-1…-N, aðeins DHCP',
      user: 'Notandi',
      userHint: 'Tómt = sjálfgefinn notandi myndarinnar (Linux) eða Administrator (Windows)',
      password: 'Lykilorð',
      passwordHint: 'Skrifað í myndaða user-data, sem kerfið lýsir síðan yfir sem leynilegri: enginn les hana aftur',
      sshKeys: 'Opinberir SSH-lyklar',
      sshKeysHint: 'Einn í hverri línu (ssh-ed25519 AAAA… athugasemd)',
      productKey: 'Windows-vörulykill',
      kmsServer: 'KMS-þjónn',
      kmsHint: 'Hýsill eða hýsill:gátt — krefst vörulykils (KMS-biðlaralykils)',
      adDomain: 'Tengjast Active Directory-léni',
      adDomainHint: 'Tómt = engin lénstenging',
      adUser: 'Tengireikningur',
      adPassword: 'Lykilorð tengireiknings',
      adOu: 'Mark-OU (valfrjálst)',
      advanced: 'Ítarlegt: hrá skjöl',
      userData: 'user-data (hrá)',
      userDataHint: 'Kemur í stað myndaðrar user-data: notandi, lykilorð, lyklar og Windows-reitirnir hér að ofan verða að vera tómir',
      networkConfig: 'network-config (hrá)',
      networkConfigHint: 'Kemur í stað myndaðs nets: IP, gátt og DNS hér að ofan verða að vera tóm',
      secret: 'Meðhöndla hráa user-data sem leynilega',
      secretHint: 'Merkt leynileg hættir API að skila henni til nokkurs og hún ferðast innsigluð með masterpass í Checkpoint',
      startNow: 'Ræsa strax',
      startNowHint: 'Hvert tilvik ræsist um leið og það er skilgreint; seed verður til við þá ræsingu'
    },

    create: {
      nicAttachmentNetwork: 'Rökrétt net (fabric)',
      nicNetwork: 'Rökrétt net',
      nicNetworkHint: 'RÁÐLAGÐA leiðin (F3): vNIC raungerist á AFLEIDDU brúnni á þjónandi hnútnum — brúin fæðist við skýrt fabric-apply, og ræsing á hnút sem ber hana ekki enn synjar talandi. Þegar síðasta tilvísun flotans fer, dettur brúin út við næsta apply.',
      button: 'Búa til VM',
      title: 'Búa til sýndarvél',
      dialogTitle: 'Búa til sýndarvél',
      stepGeneral: 'Almennt',
      stepGeneralHint: 'Nafn og prófíll',
      stepCompute: 'CPU og vinnsluminni',
      stepComputeHint: 'Grannfræði og stærðir',
      stepDisks: 'Diskar',
      stepDisksHint: 'Búa til eða tengja',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Drif og miðlar',
      stepNetwork: 'Net',
      stepNetworkHint: 'NIC: trunk eða brú',
      stepSummary: 'Samantekt',
      stepSummaryHint: 'Yfirfara og búa til',
      name: 'Nafn',
      nameHint: 'Lágstafir, tölustafir og bandstrik (DNS-1123)',
      nextButton: 'Áfram',
      prevButton: 'Til baka',
      submitButton: 'Búa til',
      creating: 'Stofnun…',
      sockets: 'Socket',
      cores: 'Kjarnar á socket',
      threads: 'Þræðir á kjarna',
      totalVcpus: 'vCPU alls',
      memoryGib: 'Minni (GiB)',
      cpuModelHint: "'host' sýnir CPU hýsilsins",
      cpuLimitHint: 'Þak í hýsilkjörnum — autt = ótakmarkað',
      cpuNestedHint: "Opnar vmx/svm fyrir gestinn svo hann geti keyrt eigin hypervisor — krefst CPU-gerðarinnar host og hnúts með nested virkt",
      newDisk: 'Nýr diskur',
      attachDisk: 'Tengja fyrirliggjandi disk',
      diskStorage: 'Geymsla',
      diskSize: 'Stærð (GiB)',
      diskSelect: 'Diskur',
      addDisk: 'Bæta við diski',
      addCdrom: 'Bæta við CD/DVD-drifi',
      addNic: 'Bæta við nettengi',
      remove: 'Fjarlægja',
      slotLimit: 'Raufamörkum náð',
      cdromImage: 'Mynd (tómt drif ef engin)',
      nicAttachment: 'Tenging',
      nicAttachmentTrunk: 'Overlay-trunk',
      nicAttachmentBridge: 'Hýsilbrú',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Ekkert (aðeins tagged)',
      nicTrunkHint: 'Að minnsta kosti önnur hliðin: untagged overlay og/eða tagged VLAN-varpanir — VM-in getur aðeins keyrt á hýslunum sem hvert tilvísað overlay lýsir yfir',
      nicTaggedVlan: 'VLAN-ID',
      nicTaggedOverlay: 'Overlay-net',
      addTagged: 'Bæta við tagged VLAN-i',
      nicBridge: 'Nafn hýsilbrúarinnar',
      nicBridgeHint: 'NM-brú eftir nafni — VM-in getur aðeins keyrt á þjónum þar sem hýsilnetið lýsir yfir þessari brú',
      nicMac: 'MAC (sjálfvirkt ef autt)',
      noDisksHint: 'Enginn diskur: VM-in mun aðeins hafa CD/DVD-drifin sem þú bætir við.',
      noCdromsHint: 'Ekkert CD/DVD-drif: bættu einu við til að ræsa af ISO-mynd.',
      mountGuestTools: 'Setja inn TVirt Guest Tools við fyrstu ræsingu',
      mountGuestToolsHint: 'Setur ISO-myndina með virtio-reklunum og guest agent-inum í tómt CD-drif (bætt við ef þarf) — Windows-uppsetningarforritið þarf hana til að sjá diskana.',
      noNicsHint: 'Ekkert nettengi: VM-in ræsist án nettengingar.',
      taggedMappings: 'Tagged VLAN-varpanir',
      summaryDevices: 'Tæki',
      bootOrderTitle: 'Ræsiröð',
      bootOrderHint: 'Dragðu til að endurraða — fyrsta ræsanlega tækið vinnur; NIC ræsa PXE',
      bootOrderUp: 'Færa upp',
      bootOrderDown: 'Færa niður',
      createError: 'Stofnun mistókst'
    },
    edit: {
      button: 'Breyta',
      title: 'Breyta sýndarvél',
      cancel: 'Hætta við',
      save: 'Vista',
      error: 'Breyting mistókst',
      modelStoppedOnly: 'Aðeins breytanlegt á slökktri VM',
      firmwareStoppedOnly: 'Fastbúnaður aðeins breytanlegur á slökktri VM — við næstu ræsingu fer vélin í gang með nýja fastbúnaðinn og UEFI-breyturnar haldast',
      hugePagesStoppedOnly: 'Aðeins breytanlegt á slökktri VM — við næstu ræsingu fæðist minnið með nýja bakgrunninum',
      runningHint: 'Breytingarnar taka gildi við næsta power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Minni',
      sectionPolicy: 'Stefnur'
    },
    devices: {
      networkChip: 'fabric-net',
      title: 'Tæki',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Bæta við USB-tæki',
      addUsbTitle: 'Biðja um flokk USB-tækja',
      usbClassHint:
        'VM-in biður um FLOKK USB-tækja (gildi á usb-device-merki), aldrei tiltekið tæki: við ræsingu er raunverulega lausa tækið á hnútnum valið og frátekið. Merktu skráðu tækin í Klasi › USB- og PCIe-auðlindir.',
      usbTag: 'Merki (usb-device)',
      usbValue: 'Gildi flokksins',
      noUsbTags: 'Ekkert usb-device-merki — búðu eitt til og merktu skráðu tækin í Klasi › USB- og PCIe-auðlindir.',
      noUsbValues: 'Þetta merki á enn engin yfirlýst gildi.',
      usbEmpty: 'Engin USB-krafa — bættu við flokki til að rétta tæki áfram við ræsingu.',
      usbClassChip: 'flokkur',
      usbPortChip: 'port',
      usbUnclaimed: 'Ekkert tæki frátekið — leysist við ræsingu VM-arinnar.',
      addGpu: 'Bæta við GPU',
      addGpuTitle: 'Biðja um GPU-flokk',
      gpuClassHint:
        'VM-in biður um FLOKK af GPU (gildi á gpu-device-merki), aldrei tiltekið kort: við ræsingu er raunverulega lausa kortið valið og frátekið á hnútnum, og ALLUR IOMMU-hópur þess fylgir með. Merktu skráðu GPU-in í Klasi › USB- og PCIe-auðlindir.',
      gpuTag: 'Merki (gpu-device)',
      gpuValue: 'Gildi flokksins',
      noGpuTags: 'Ekkert gpu-device-merki — búðu eitt til og merktu skráðu GPU-in í Klasi › USB- og PCIe-auðlindir.',
      noGpuValues: 'Þetta merki á enn engin yfirlýst gildi.',
      gpuEmpty: 'Engin GPU-krafa — bættu við flokki til að rétta kort áfram við ræsingu.',
      gpuClassChip: 'flokkur',
      gpuGroupChip: 'IOMMU-hópur ×',
      gpuUnclaimed: 'Ekkert kort frátekið — leysist við ræsingu VM-arinnar.',
      gpuPowerCycle: 'Ekkert GPU-hotplug — breytingarnar gilda frá næsta power cycle (PendingRestart)',
      actions: 'Aðgerðir',
      attachDisk: 'Bæta við diski',
      attachDiskTitle: 'Bæta við diski',
      attach: 'Tengja',
      noFreeDisks: 'Enginn ónotaður diskur — búðu einn til í Sýndarvélar › Ónotaðir diskar.',
      addCdrom: 'Bæta við drifi',
      addCdromTitle: 'Bæta við CD/DVD-drifi',
      editCdromTitle: 'Skipta um CD/DVD-mynd',
      changeMedia: 'Skipta um CD/DVD-mynd',
      ejectMedium: 'Spýta út',
      mountGuestTools: 'Setja inn TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools inni',
      guestToolsClickMount: 'Setur TVirt Guest Tools ISO-myndina í fyrsta tóma CD/DVD-drifið',
      guestToolsClickUnmount: 'Smelltu til að spýta út — drifið situr eftir, tómt',
      guestToolsNoSlot: 'Ekkert tómt CD/DVD-drif — bættu við drifi (eða spýttu út miðli) til að setja inn TVirt Guest Tools',
      guestToolsSkew: 'Tengt v{pinned}; hnútur {node} þjónar nú v{current}: fjarlægðu og tengdu aftur til að uppfæra',
      ejectGuestTools: 'Spýta út TVirt Guest Tools (drifið situr eftir, tómt)',
      guestToolsEjectConfirmTitle: 'Spýta út TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Miðlinum er spýtt út úr kveiktu VM-inni — CD/DVD-drifið situr eftir, tómt.',
      applyLive: 'Framkvæma strax (VM-in er kveikt)',
      addNic: 'Bæta við tengi',
      addNicTitle: 'Bæta við nettengi',
      editNicTitle: 'Breyta nettengi',
      bridgeChip: 'brú',
      cable: 'Sýndarsnúra',
      plug: 'Tengja sýndarsnúruna',
      unplug: 'Aftengja sýndarsnúruna',
      remove: 'Fjarlægja',
      removeTitle: 'Fjarlægja {device}?',
      removeBody: 'Á kveiktri VM tekur breytingin gildi við næsta power cycle. Diskar og myndir eru aftengd, aldrei eytt.'
    }
  }
}
